import Cons from '@/constants.json'

let base = process.env.VUE_APP_API

export const endpoints = Object.freeze({
  base: base,
  me: base + 'me',
  user: base + 'user',
  profile: base + 'profile',
  prescription: base + 'prescription',
  prescribe: base + 'prescribe',
  youtubeScrape: base + 'youtube/scrape',
  linkScrape: base + 'html/scrape',
  mainbrand: base + 'brand',
  brand: base + 'doctor',
  brands: base + 'doctors',
  journal: base + 'journal',
  item: base + 'item',
  items: base + 'items',
  careplan: base + 'careplan',
  group: base + 'group',
  emergency: base + 'emergency',
  uploadBase64Img: base + 'uploadbase64image',
  developedPlans: base + 'doctor/developed/careplan',
  staff: base + 'staff',
  backlog: base + 'backlog',
  permitted: base + 'permitted/careplan',
  broadcast: base + 'broadcast',
  notifications: base + 'admin/notification',
  trash: base + 'trashed/item',
  draft: base + 'draft',
  geocoder: base + 'geocode/address?address=',
  bookmark: base + 'bookmark',
  nearby: base + 'location/nearby',
  nearbyTotal: base + 'nearby',
  pami: base + 'pami/check/insurance',
  directory: base + 'directory',
  activity: base + 'activity',
  activities: base + 'activities',
  login: base + 'login/facebook',
  checkin: base + 'checkin',
  event: base + 'event',
  preview: base + 'preview',
  paypal: base + 'paypal',
  stripe: base + 'stripe/creditcard',
  password: base + 'password',
  cities: base + 'cities',
  provinces: base + 'provinces',
  profanity: base + 'profanity',
  field: base + 'field',
  join: base + 'join/group',
  refreshToken: base + 'oauth/access_token',
  careteamRequest: base + 'private/careplan/request',
  brandByCode: base + 'brand-by-code',
  itemsRange: base + 'items/in/range',
  dynamicLink: base + 'firebase/dynamic/link'
})
